export const BUSINESS_TIMEZONE = "Asia/Makassar";

export const toDateInputValue = (date = new Date(), timezone = BUSINESS_TIMEZONE) => {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: timezone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

export const getTodayInBusinessTz = () => toDateInputValue(new Date(), BUSINESS_TIMEZONE);
